module.exports = __webpack_public_path__ + "static/media/howtobefat_preview.48e38e9c.png";